import { render, staticRenderFns } from "./tableItem.vue?vue&type=template&id=c8e95e44&scoped=true"
import script from "./tableItem.vue?vue&type=script&lang=js"
export * from "./tableItem.vue?vue&type=script&lang=js"
import style0 from "./tableItem.vue?vue&type=style&index=0&id=c8e95e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e95e44",
  null
  
)

export default component.exports